const Question = () => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-y-[2px]">
      <div className="tw-flex tw-flex-row tw-gap-x-[2px]">
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
          <path
            d="M0 1.50685C0 0.67464 0.67464 0 1.50685 0H8.73973C9.57194 0 10.2466 0.67464 10.2466 1.50685V8.73973C10.2466 9.57194 9.57194 10.2466 8.73973 10.2466H1.50685C0.67464 10.2466 0 9.57194 0 8.73973V1.50685Z"
            fill="#C2C9FE"
          />
          <path
            d="M5.12402 1.80859C5.53997 1.80878 5.87695 2.14651 5.87695 2.5625V4.37012H7.68555C8.10155 4.37024 8.43848 4.70799 8.43848 5.12402C8.43828 5.53989 8.10143 5.87683 7.68555 5.87695H5.87695V7.68555C5.87682 8.10142 5.53989 8.43829 5.12402 8.43848C4.708 8.43848 4.37025 8.10154 4.37012 7.68555V5.87695H2.5625C2.14652 5.87695 1.80879 5.53996 1.80859 5.12402C1.80859 4.70792 2.14639 4.37012 2.5625 4.37012H4.37012V2.5625C4.37012 2.14639 4.70792 1.80859 5.12402 1.80859Z"
            fill="#5776FC"
          />
          <path
            opacity="0.25"
            d="M0.753425 7.38356C0.753425 4.66953 1.53361 2.13782 2.88156 0H1.50685C0.67464 0 0 0.67464 0 1.50685V8.73973C0 9.40657 0.433293 9.97188 1.0336 10.1704C0.849879 9.2701 0.753425 8.33809 0.753425 7.38356Z"
            fill="#5776FC"
          />
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
          <rect width="10.2466" height="10.2466" rx="1.50685" fill="#F490B0" />
          <path d="M2.5625 5.12402H7.68579" stroke="#E33480" strokeWidth="1.50685" strokeLinecap="round" />
          <rect width="10.2466" height="10.2466" rx="1.50685" fill="#F490B0" />
          <path
            d="M7.68531 4.37012C8.10141 4.37012 8.43873 4.70744 8.43873 5.12354C8.43873 5.53965 8.10141 5.87697 7.68531 5.87697H2.56202C2.14591 5.87697 1.80859 5.53965 1.80859 5.12354C1.80859 4.70744 2.14591 4.37012 2.56202 4.37012H7.68531Z"
            fill="#E33480"
          />
        </svg>
      </div>

      <div className="tw-flex tw-flex-row tw-gap-x-[2px]">
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
          <rect width="10.2466" height="10.2466" rx="1.50685" fill="#4EE3C0" />
          <path d="M3.3125 3.31152L6.93521 6.93423" stroke="#2E9079" strokeWidth="1.50685" strokeLinecap="round" />
          <path d="M6.93555 3.31152L3.31284 6.93423" stroke="#2E9079" strokeWidth="1.50685" strokeLinecap="round" />
          <path
            opacity="0.3"
            d="M10.2453 8.78961C6.10501 7.41504 2.83134 4.14144 1.45682 0.00117723C0.647773 0.0275772 0 0.691386 0 1.50685V8.73973C0 9.57194 0.67464 10.2466 1.50685 10.2466H8.73973C9.55524 10.2466 10.2189 9.59872 10.2453 8.78961Z"
            fill="#38AA8F"
          />
          <path
            d="M6.40231 2.77925C6.69656 2.48519 7.17357 2.48508 7.46774 2.77925C7.76179 3.07343 7.76176 3.55047 7.46774 3.84468L6.18845 5.123L7.46774 6.4023C7.76161 6.69654 7.76182 7.17361 7.46774 7.46773C7.17363 7.76184 6.69657 7.76161 6.40231 7.46773L5.12302 6.18843L3.8447 7.46773C3.55049 7.76176 3.07345 7.76178 2.77927 7.46773C2.48509 7.17355 2.4852 6.69654 2.77927 6.4023L4.05759 5.123L2.77927 3.84468C2.48504 3.55045 2.48504 3.07348 2.77927 2.77925C3.0735 2.48505 3.55048 2.48503 3.8447 2.77925L5.12302 4.05757L6.40231 2.77925Z"
            fill="#2E9079"
          />
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
          <rect width="10.2466" height="10.2466" rx="1.50685" fill="#3FDEFB" />
          <path d="M2.56445 4.06836H7.68774" stroke="#22889A" strokeWidth="1.50685" strokeLinecap="round" />
          <path d="M7.6875 6.17871L2.56421 6.17871" stroke="#22889A" strokeWidth="1.50685" strokeLinecap="round" />
          <path
            d="M7.6875 5.4248C8.10356 5.42485 8.44043 5.76264 8.44043 6.17871C8.44037 6.59473 8.10353 6.93159 7.6875 6.93164H2.56445C2.14839 6.93164 1.81061 6.59476 1.81055 6.17871C1.81055 5.76261 2.14835 5.4248 2.56445 5.4248H7.6875ZM7.6875 3.31543C8.10339 3.31549 8.44017 3.65251 8.44043 4.06836C8.44043 4.48443 8.10356 4.82221 7.6875 4.82227H2.56445C2.14835 4.82227 1.81055 4.４８４４６ 1.81055 ４．０６８３６C１．８１０８１ ３．６５２４８ ２．１４８５１ ３．３１５４３ ２．５６４４５ ３．３１５４３H７．６８７５Z"
            fill="#22889A"
          />
          <path
            opacity="0.25"
            d="M10.2467 8.73994C10.2467 9.57215 9.57203 10.2468 8.73982 10.2468H1.50694C0.840031 10.2468 0.274593 9.81344 0.0761719 9.21304C0.976475 9.39679 1.90851 9.49336 2.86311 9.49336C5.57714 9.49336 8.10885 8.71318 10.2467 7.36523V8.73994Z"
            fill="#2CA4B9"
          />
        </svg>
      </div>
    </div>
  );
};

export default Question;
